/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".marginauto[_ngcontent-%COMP%]{margin:0 auto}\n/*# sourceMappingURL=addproduct.component.css.map*/"];
export { styles as styles };
